export default __webpack_public_path__ + "static/media/no-user-icon.3e49daaf.svg";